<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import { authHeader } from "../../../helpers/auth-header";

import ConfirmationModal from "@/components/modals/confirmation-modal";
import MessageModal from "@/components/modals/message-modal";

import InputGroup from "@/components/forms/input-group";

import SaveButton from "@/components/buttons/save-button";
import CancelButton from "@/components/buttons/cancel-button";

/**
 * Orders Component
 */
export default {
    components: {
        Layout,
        PageHeader,
        ConfirmationModal,
        MessageModal,
        InputGroup,
        SaveButton,
        CancelButton
    },
    data() {
        const id = this.$route.params.id;
        const modeName = id === 'add' ? 'Add' : 'Edit';

        return {
            id: id,
            title: `${modeName} Student Grade Category`,
            modeName,
            items: [
                {
                    text: "Student grade category"
                },
                {
                    text: modeName,
                    active: true,
                },
            ],
            data: {
                name: '',
                service_id: '',
                rate: '',
            },
            serviceOptions: [],
            tutorOptions: [],
            selectedTutors: [],
            errors: {},
        };
    },
    async mounted() {
        const services = await this.retrieveServices();
        this.serviceOptions = services.map(service => ({
            name: service.name,
            value: service.id,
        }));

        this.retrieveTutors().then((tutors) => {
            this.tutorOptions = tutors.map((tutor) => ({
                name: tutor.name,
                value: tutor.id,
            }));
        });

        if (this.modeName !== 'Add') {
            const result = await axios.get(`${process.env.VUE_APP_APIURL}/field_management/student_grade_category/${this.id}`, {
                headers: authHeader(),
            });

            if (result && result.data['code'] === 'success') {
                const data = result.data['data']['student_grade_category'];
                for (const [key, item] of Object.entries(data)) {
                    if (key in this.data) {
                        this.data[key] = item;
                    } else if (key === 'tutor_types') {
                        this.selectedTutors = JSON.parse(item) ?? [];
                    }
                }
            }
        }        
    },
    methods: {
        toggleTutorCheckbox(tutorId) {
            const index = this.selectedTutors.indexOf(tutorId);
            if (index !== -1) {
                this.selectedTutors.splice(index, 1);
            } else {
                this.selectedTutors.push(tutorId);
            }
        },

        async retrieveServices() {
            this.loading = true;
            let services = [];

            try {
                const item = await axios.get(`${process.env.VUE_APP_APIURL}/field_management/service`, {
                    headers: authHeader(),
                });

                const result = await item.data;
                if (result['code'] === 'success') {
                    const serviceDetails = result['data'].services;
                    services = serviceDetails.filter(service => service.status == 1);
                }
            } catch (e) {
                console.error(e);
            }

            this.loading = false;
            return services;
        },

        async retrieveTutors() {
            this.loading = true;
            let tutors = [];

            try {
                const item = await axios.get(`${process.env.VUE_APP_APIURL}/field_management/tutor_type`, {
                    headers: authHeader(),
                });

                const result = await item.data;
                if (result['code'] === 'success') {
                    const tutorDetails = result['data'].tutor_types;
                    tutors = tutorDetails.filter(type => type.status == 1);
                }
            } catch (e) {
                console.error(e);
            }

            this.loading = false;
            return tutors;
        },

        async save() {
            this.errors = {};
            let result;
            if (this.modeName === 'Add') {
                const requestData = this.data;
                result = await axios.post(`${process.env.VUE_APP_APIURL}/field_management/student_grade_category`, requestData, {
                    headers: authHeader(),
                });
            } else {
                const requestData = this.data;
                requestData.tutor_types = this.selectedTutors;

                result = await axios.put(`${process.env.VUE_APP_APIURL}/field_management/student_grade_category/${this.id}`, requestData, {
                    headers: authHeader(),
                });
            }

            if (result) {
                if (result.data['code'] === 'success') {
                    if (this.modeName === 'Add') {
                        this.$router.back();
                    } else {
                        this.$refs.messageModal.showModal('Your record has been updated successfully');
                    }
                } else if (result.data['code'] === 'invalid_field') {
                    this.errors = result.data['errors'];
                }
            }
        },
        cancel() {
            this.$router.push({ name: "Student Grade Category" });
        }
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <ConfirmationModal ref="confirmationModal" />
        <MessageModal ref="messageModal" />
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body p-4">
                        <div class="row mt-2">
                            <div class="col-12 col-md-4 mb-2">
                                <InputGroup type="text" id="name" displayName="Name" v-model="data.name" :error="errors.name" />
                            </div>
                        </div>

                        <div class="divider"></div>

                        <div class="row mt-2" style="float: right;">
                            <div class="col-12">
                                <CancelButton @click="cancel"></CancelButton>
                                <SaveButton :isSubmit="true" :text="'Save'" @click="save" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>